//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "./store"
import { _slug } from "./helpers"

export default {
  name: 'FilterCheckboxGroup',
  
  props: ['group_type','group','hasSelectAll'],
  
  data: function() {
    return {
      filterData: null,
      title: 'default',
      selected: [],
      selectAll: false,
    }
  },
  
  created() {
    // init filter data
    if(this.group !== undefined) {
      this.filterData = window.allFilterData[this.group_type][this.group]
      // console.log(this.filterData)
    } else {
      this.filterData = window.allFilterData[this.group_type]
      
    }
    // set title
    if(this.group !== undefined) {
      this.title = this.group
    } else {
      this.title = this.group_type
    }

    this.$root.$on('clearCheckboxes', this.clearCheckboxes)
  },
  
  computed: {
    groupTotal: function() {
      let t = 0;
      for (let i in this.filterData) {
        t=t+this.filterData[i]
      }
      return t
    },
    titleId: function(e) {
      console.log(e)
      return 'filter_' + _slug(this.title) + '_' + e
    },
  },
  
  methods: {
    make_id(str) {
      // let url = '../images/icons/filter_'+str
      return _slug(this.title) + '_' +_slug(str)
    },
    // select / deselect all checkboxes
    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let key in this.filterData) {
          this.selected.push(key)
        }
      }
      this.pass_to_filter()
    },

    // pass selected items to store
    pass_to_filter() {       
      let group_type = this.group_type
      // if we have 'subregio' as group_type we update filter values for the group title
      if(group_type=='subregio') group_type = _slug(this.title)
      store.updateFilterValues(group_type, this.selected)

      // send message to update the Map
      this.$root.$emit('updateGoogleMap')
    },
    
    clearCheckboxes() {
      this.selectAll = false
      this.selected = []
    },
  },
}





// WEBPACK FOOTER //
// ./scripts/vue/FilterCheckboxGroup.vue